import { yup } from '@framework/validation';
import { Widget } from './Widget';
import { WidgetRepository } from './repository/WidgetRepository';

/**
 * Validatore lazy per un qualunque tipo di widget.
 */
export const LazyWidgetSchema = yup.lazy(
  (value: Widget | undefined): yup.ObjectSchema<Widget> => {
    const widgetType = WidgetRepository.find(value?.type);

    if (!widgetType?.configValidator) {
      // Forzo la tipizizzazione: il campo verrebbe comunque rimosso e a noi non interessa.
      // In teoria non dovrebbe mai capitare.
      return yup
        .object()
        .meta({ widget: value?.type ?? 'unknown' })
        .notRequired()
        .strip() as unknown as yup.ObjectSchema<Widget>;
    }
    return widgetType.configValidator.noUnknown().meta({
      widget: widgetType.type,
    }) as yup.ObjectSchema<Widget>;
  },
) as yup.Lazy<Widget>;
